import React, { useEffect, useState, Fragment } from 'react'
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { v4 as uuid } from 'uuid'

// Hooks
import useWindowSize from '../../../../Hooks/useWindowSize'

// Atoms
import Title, { TitleTag, TitleStyle } from '../../../Atoms/Title';

// Molecules
import PlayComPlanCardMol from '../../../Molecules/Cards/Plan/PlayCompare'

// Sass
import '../../../../Sass/includes/Components/modules/C25.sass'

function C25Personas(props) {
    let dataCompare = props.dataCompare ? props.dataCompare : []
    const {
        resetHandleClick,
        removeItemHandleClick,
    } = props
    console.log("C25Personas..................", props.dataCompare, dataCompare.items)
 

    const [itemsResponsive, setItemsResponsive] = useState([])

 
    const {
        width: widthWindos,
    } = useWindowSize()

    useEffect(() => {
        setItemsResponsive([dataCompare.items[0]?.fi_PLAN, dataCompare.items[1]?.fi_PLAN])
        // eslint-disable-next-line
    }, [])

    const itemsId = widthWindos > 960 ? dataCompare.items.map(item => item.fi_PLAN) : itemsResponsive
    const findItemIndex = (item) => dataCompare.items.findIndex(el => el.fi_PLAN === item.fi_PLAN)

    const handlePrevPlan = (item, i) => {
        const newResposive = [...itemsResponsive]
        console.log('index ant al valor actual:', findItemIndex(item) - 1)

        newResposive[i] = findItemIndex(item)
            ? dataCompare.items[findItemIndex(item) - 1]?.fi_PLAN === itemsResponsive[i - 1] //Comprueba si el valor anterior no es el mismo que ya esta en el anterior index
                ? item.fi_PLAN //retorna el valor de elemento actual
                : dataCompare.items[findItemIndex(item) - 1]?.fi_PLAN //retorna el nuevo valor
            : item.fi_PLAN
        setItemsResponsive(newResposive)
    }

    const handleNextPlan = (item, i) => {
        console.log(itemsResponsive)
        console.log('index sig al valor actual:', findItemIndex(item) + 1)

        const newResposive = [...itemsResponsive]
        newResposive[i] = dataCompare.items[findItemIndex(item) + 1]?.fi_PLAN
            ? dataCompare.items[findItemIndex(item) + 1]?.fi_PLAN === itemsResponsive[i + 1] //comprueba  si el valor siguiente no es el mismo que ya esta en el siguirnte index
                ? item.fi_PLAN //retorna el valor de elemento actual
                : dataCompare.items[findItemIndex(item) + 1]?.fi_PLAN //retorna el nuevo valor
            : item.fi_PLAN
        setItemsResponsive(newResposive)
    }

    const _renderCompare = items => (
        items && items.length > 0
            ? items
                .filter(item => itemsId.includes(item.fi_PLAN))
                .map((item, index) =>
                    <div
                        key={item.fi_PLAN}
                        className={'c25CompItemsBodyService'}
                    >
                        <div className='c25CompItemsBodyHeader'>
                            <div className='c25CompItemsBodyNavegate'>
                                <i className='ico-chevron-left' aria-label='Plan Anterior' onClick={() => handlePrevPlan(item, index)} />
                                <p>Comparar otro</p>
                                <i className='ico-chevron-right' aria-label='Plan Siguiente' onClick={() => handleNextPlan(item, index)} />
                            </div>
                            <div className='c25CompItemsBodyPagination'>
                                <p>
                                    {items.findIndex(el => el.fi_PLAN === item.fi_PLAN) + 1} de {items.length} {'Planes'}
                                </p>
                            </div>
                        </div>

                        <div className='c25CompItemsBodyClose'>
                            <i className='ico-x' name={item.fi_PLAN} id={item.fi_PLAN} onClick={removeItemHandleClick} />
                        </div>
                        <PlayComPlanCardMol
                            {...item}
                        />

                    </div>
                )
            : 'No hay datos'
    )

    const _renderFeaturesPlan = (item) => {

        const {
            caracteristicas,
        } = item

        const searchCharacteristics = (search, TypeFlag = false, Caracteristicas) => {
            if (TypeFlag) {
                const data = Caracteristicas.length ? Caracteristicas : [];
                const newCaractData = data.filter(function (CaracData) {
                    let CaracDESCRIPCION = []

                    CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                    return CaracDESCRIPCION.indexOf(search) > -1
                })
                console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
                return newCaractData
            } else {
                const data = Caracteristicas.length ? Caracteristicas : [];
                const newCaractData = data.filter(function (CaracData) {
                    let CaracDESCRIPCION = []

                    CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                    return CaracDESCRIPCION.indexOf(search) === -1
                })
                console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
                return newCaractData
            }
        }

        let CharactBlock = searchCharacteristics('Tipo Footer', false, caracteristicas)
        let CharactFooter = searchCharacteristics('Tipo Footer', true, caracteristicas)

        console.log("Characteristics*******************************: " + CharactBlock, CharactFooter, caracteristicas)
        
        return (
            <Fragment>
                {
                    CharactFooter.length
                        ?
                        CharactFooter.map((caract, index) => (
                            <div className='c25FeatListItemRelevant'>
                                <div className='c25FeatListContIcon'>
                                    {
                                        caract.fc_CLASE_ICONO ?
                                            <i className={`${caract.fc_CLASE_ICONO}`} aria-label='icono' />
                                            : null
                                    }
                                </div>
                                <div className='c25FeatListCont'>
                                    <p className='c25FeatListValue'>{caract.fc_TITULO}</p>
                                    <p className='c25FeatListFeature'>{caract.fc_VALOR}</p>
                                </div>
                            </div>
                        ))
                        : null
                }
                {
                    CharactBlock.length
                        ?
                        CharactBlock.map((caract, index) => (
                            caract.fc_VALOR.includes("logo")
                                ?
                                <div key={index} className='c25FeatListItem' >
                                    <p className='c25FeatListFeature'>{caract.fc_TITULO}</p>
                                    <p className='c25FeatListValue'>{caract.fc_VALOR}</p>
                                </div>
                                :
                                <div key={index} className='c25FeatListItem'>
                                    <p className='c25FeatListFeature'>{caract.fc_TITULO}</p>
                                    {
                                        caract.fc_DESCRIPCION.includes("Redes Sociales")
                                            ?
                                            <p className="c25FeatListValue">
                                                {
                                                    caract.fc_VALOR.split("|").map((icoRed, index) => (
                                                        <span key={uuid()}>
                                                            <i className={icoRed} />
                                                        </span>
                                                        
                                                    ))
                                                }
                                            </p>
                                            :
                                            <p className='c25FeatListValue'>{caract.fc_VALOR}</p>
                                    }
                                </div>
                        ))
                        : 'No hay caracteristicas disponibles'
                }

            </Fragment >
        )

    }

    const filterItemsShow = items => items.filter(item => itemsId.includes(item.fi_PLAN))

    const _renderItems = items => (
        items && items.length > 0
            ? items.map((item, index) =>
                
                <div
                    className='c25FeatsList'
                    key={item.fi_PLAN || item.fc_TEXTO_CAJA || index}
                >
                    {_renderFeaturesPlan(item)}
                </div>
            ) : 'No hay caracteristicas'
    )

    return (
        <section className='c25Wrap'>
            <div className="container">

                <div className="c25">
                    <div className="c25Back">
                        <div className='c25BackReturn' onClick={resetHandleClick}>

                            <i className='ico-chevron-left'></i>
                            <span>Regresar a ver todos los planes</span>
                        </div>
                    </div>
                    <div className="c25Header">

                        <Title
                            tag={TitleTag.h2}
                            style={TitleStyle.h1}
                        >
                            Comparar Servicios
                        </Title>
                    </div>


                    <div className='c25CompItems'>
                        <div className="container c25CompItemsContainer">

                            <div className='c25CompItemsHeader'>

                                <p>Comparativa</p>
                                <div className='c25CompItemsHeaderClose' onClick={resetHandleClick}>
                                    <i className="ico-x"></i>
                                </div>
                            </div>

                            <div className='c25CompItemsBody'>
                                {dataCompare.isFetching
                                    ? <div>Cargando...</div>
                                    : _renderCompare(dataCompare.items.slice(-4))
                                }

                            </div>
                            <div className='c25CompItemsFeactures'>
                                <div className='c25FeatsBlockMain'>
                                    <SimpleBar style={{ maxHeight: 500 }}>
                                        <div className='c25FeatsBlockCont'>
                                            {_renderItems(filterItemsShow(dataCompare.items.slice(-4)))}

                                        </div>
                                    </SimpleBar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default C25Personas
